import React from 'react';
import { config } from "../config";

class ArticleLinks extends React.Component {
    constructor(props) {
        super(props);
        this.images = {};
        this.imagesCount = 0;
        this.imagesLoaded = 0;
        this.impModel = null;
        this.fundModel = [];
        this.state = {
            images: {}
        };
    }

    apiUrl() {
        return config.WORDPRESS_API;
    }

    getImpModelId() {
        if(!this.props.state.implementationModel) return null;
        let impModels = this.props.state.implementationModels,
            modelId;
        impModels.forEach((model) => {
            if(this.props.state.implementationModel === model.slug && model.taxonomies && model.taxonomies.length) {
                modelId = model.taxonomies[0].term_id;
            }
        });
        return modelId || null;
    }

    getFundModelIds() {
        if(!this.props.state.selectedFundings.length) return "";
        let fundModels = this.props.state.fundingModels,
            selectedModels = this.props.state.selectedFundings,
            fundModelIds = [];
        fundModels.forEach((model) => {
            if(selectedModels.includes(model.slug) && model.taxonomies && model.taxonomies.length) {
                fundModelIds.push(model.taxonomies[0].term_id);
            }
        });
        return fundModelIds.toString();
    }

    componentDidUpdate() {
        if (this.phase === this.props.state.phase
              && this.impModel === this.props.state.implementationModel
              && this.fundModel.toString() === this.props.state.selectedFundings.toString()) return;
        let url = "",
            impModelId = this.getImpModelId(),
            fundModelIds = this.getFundModelIds();
        this.images = {};
        this.imagesCount = 0;
        this.imagesLoaded = 0;
        this.phase = this.props.state.phase;
        this.impModel = this.props.state.implementationModel;
        this.fundModel = this.props.state.selectedFundings.slice();
        url = this.apiUrl() + "/wp-json/wp/v2/solutions?" +
              (impModelId && this.phase === 1 ? "investment_models="+impModelId+"&" : "") +
              (fundModelIds.length ? "solution="+fundModelIds+"&" : "") +
              "per_page=3";
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json'
            }),
        })
        .then((resp) => resp.json())
        .then((data) => data.slice(0, 3))
        .then((response) => {
            this.props.updateState({articleLinks: response});
            response.forEach((item) => {if(item.featured_media) this.imagesCount++;});
            response.forEach((item) => {
                if(item.featured_media) {
                    this.getPostImage(item.featured_media)
                };
            });
        }).catch((error) => {
            console.log("error in article links",error);
        });
    }

    createTags(item) {
        let tags = [];
        item.investment_models?.forEach(investment_model => {
            tags.push(<li key={"imp-model-"+investment_model}>{investment_model}</li>)
        })
        item.solution?.forEach(solution => {
            tags.push(<li key={"fund-model-"+solution}>{solution}</li>)
        })
        return tags;
    }

    getPostImage(id) {
        let url = this.apiUrl() + "/wp-json/wp/v2/media/" + id;
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json'
            }),
        })
        .then((resp) => resp.json())
        .then((response) => {
            this.images["img"+id] = response.media_details.sizes.thumbnail;
            this.imagesLoaded++;
            if(this.imagesCount === this.imagesLoaded) {
                this.setState({images: this.images});
            }
        }).catch((error) => {
            console.log("error in get image media: "+id,error);
        });
    }

    render() {
        return (
            this.props.state.articleLinks && this.props.state.articleLinks.length ?
                <div className="article-links">
                    {this.props.state.articleLinks.map((item) =>
                        <a className="article-link"
                        key={'article-link'+item.id}
                        target="_parent"
                        href={item.link}>
                            <h4>{item.title.rendered}</h4>
                            {item.featured_media && this.state.images["img"+item.featured_media] ?
                                <img src={this.state.images["img"+item.featured_media].source_url} alt="" /> : null
                            }
                            <ul className="article-link__tags">{this.createTags(item)}</ul>
                        </a>
                    )}
                </div>
            : null
        );
    }
}

export default ArticleLinks;
